// extracted by mini-css-extract-plugin
export default {"listHolder":"styles_listHolder__GMb4n","open":"styles_open__9IwY4","list":"styles_list__1r00k","item":"styles_item__Mltz7"};